import { Controller } from "@hotwired/stimulus"

// Updates a display element with the current value of a range input.
// Usage:
//   <div data-controller="range-display">
//     <input type="range" data-range-display-target="input" data-action="input->range-display#update">
//     <span data-range-display-target="output">5</span>
//   </div>
export default class extends Controller {
  static targets = ["input", "output"]

  update() {
    this.outputTarget.textContent = this.inputTarget.value
  }
}
